import { useEffect, useState } from 'react';
import { getJourneyBySlug } from '../../utils/JourneyUtils';

export const useCurrentJourney = (profileQuery, programmeSlug) => {
  const [journey, setJourney] = useState(null);

  useEffect(() => {
    if (programmeSlug) {
      if (!profileQuery?.isSuccess || profileQuery?.isUninitialized) {
        return;
      }

      const currentJourney = getJourneyBySlug(
        profileQuery?.data,
        programmeSlug
      );

      setJourney(currentJourney);
    }
  }, [profileQuery, programmeSlug]);

  return journey;
};
